export const OverviewIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.72981 9.02921C2.60325 8.90265 2.60517 8.69553 2.73173 8.56897C5.6173 5.6834 10.3835 5.6834 13.2691 8.56897C13.3957 8.69553 13.3976 8.90265 13.271 9.02921C10.3601 11.9401 5.64068 11.9401 2.72981 9.02921Z"
      fill="#00082F"
      fillOpacity="0.275"
    />
    <path
      d="M2.72964 7.42911C2.60309 7.30255 2.60501 7.09543 2.73157 6.96887C5.61714 4.0833 10.3834 4.0833 13.2689 6.96887C13.3955 7.09543 13.3974 7.30255 13.2709 7.42911C10.36 10.34 5.64052 10.34 2.72964 7.42911Z"
      fill="#00082F"
      fillOpacity="0.275"
    />
  </svg>
);
